// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable no-underscore-dangle */
import React, { useContext, useState } from 'react';
import { Box, Heading, Button, Text, Image, Layer, Select } from 'grommet';
import { FormNextLink, Close } from 'grommet-icons';
import { AppHostContext } from '../../services/appHost';

import { UserContext } from '../../services/Session';
import axios from '../../helpers/axios';
import { BasicLoader } from '../../helpers/Loaders';
import { analytics } from '../../services/analytics';

const SportsRecruitsInfoModal = ({ player, onClose, showCTA }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const userStore = useContext(UserContext);
  const appHost = useContext(AppHostContext);
  const appHostService = appHost.isHosted ? appHost.service : undefined;

  const authorize = async (playerId) => {
    analytics.track('Connect to SportsRecruits Clicked', {
      playerId,
      fromSRBadge: true,
    });

    setLoading(true);

    const response = await axios.post(`/api/sr/player/${playerId}/authorize`);
    setLoading(false);
    if (response.data.isSuccess) {
      const srUrl = await axios.get(`/api/sr/player/${playerId}/landing_page`);
      if (appHost.isHosted) {
        appHostService?.notifications.openAppLink(srUrl);
        onClose();
      } else {
        const newWindow = window.open('', '_blank');
        newWindow.location = srUrl;
        onClose();
      }
    } else {
      setError('Failed to authorize. Please try again.');
    }
  };

  const renderCTA = () => {
    if (showCTA) {
      if (
        userStore.userPlayers.filter((p) => p.srUserId === null).length === 0
      ) {
        // all of user's players are connected to SR or user has no players
        return null;
      }
      if (
        userStore.userPlayers.filter((p) => p.srUserId === null).length === 1
      ) {
        // show just a single button
        const userPlayer = userStore.userPlayers.filter(
          (p) => p.srUserId === null
        )[0];
        const { _id: playerId } = userPlayer;
        return (
          <Button
            size="large"
            primary
            icon={loading && <BasicLoader size={32} />}
            disabled={loading}
            label={`Connect ${userPlayer.nameFirst} to SportsRecruits`}
            onClick={() => {
              // admin needs to authorize the app first
              authorize(playerId);
            }}
          />
        );
      }
      // show a dropdown
      return (
        <Box gap="medium">
          <Text weight="bold">
            Select a player to connect to SportsRecruits.
          </Text>
          <Select
            options={userStore.userPlayers
              .filter((p) => p.srUserId === null)
              .map((p) => ({
                ...p,
                name: `${p.nameFirst} ${p.nameLast}`,
              }))}
            labelKey="name"
            valueKey="_id"
            placeholder="Select a player"
            onChange={({ option }) => {
              const playerId = option._id;
              authorize(playerId);
            }}
          />
          {loading && <BasicLoader size={32} />}
        </Box>
      );
    }
    return null;
  };

  return (
    <Layer onEsc={onClose} onClickOutside={onClose}>
      <Box pad="medium">
        <Box direction="row" justify="between" fill="horizontal">
          <Heading level={4}>SportsRecruits x sidelineHD</Heading>
          <Button icon={<Close />} onClick={onClose} />
        </Box>
        <Box gap="large">
          <Box gap="medium">
            <Text>{`${player.nameFirst} has a profile on SportsRecruits, the #1 way to get recruited`}</Text>
            <Button
              primary
              color="#D04B28"
              label={`See ${player.nameFirst}'s profile`}
              onClick={() => {
                window.open(player.srProfileUrl, '_blank');
              }}
            />
          </Box>
          <Box margin={{ top: 'large' }}>
            <Text>
              When you connect sidelineHD to SportsRecruits, your best plays
              will automatically show up in your SportsRecruits video library.
            </Text>
            <Box
              direction="row"
              gap="medium"
              justify="center"
              align="center"
              margin="medium"
            >
              <Image src="/logo192.png" width="48px" />
              <FormNextLink />
              <Image
                src="/sr_logo.png"
                width="48px"
                style={{ transform: 'translateY(-3px)' }}
              />
            </Box>
          </Box>
          {renderCTA()}
          {error && <Text color="status-error">{error}</Text>}
        </Box>
      </Box>
    </Layer>
  );
};

export default SportsRecruitsInfoModal;
